import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export const Tomos = () => {
  const ninos = [{
    title: 'TOMO 1 — Inicial Niños (Parte 1)',
    desc: 'El primer contacto con los patines. Equilibrio, marcha, freno en T y confianza.'
  }, {
    title: 'TOMO 2 — Inicial Niños (Parte 2)',
    desc: 'Desliz atrás, giros básicos, paloma y primera secuencia completa.'
  }, {
    title: 'TOMO 3 — Intermedio Niños (Parte 1)',
    desc: 'Salto del Vals, Salchow, Mapes y primer trompo en un pie.'
  }, {
    title: 'TOMO 4 — Intermedio Niños (Parte 2)',
    desc: 'Flip, Lutz, trompo bajo inicial y combinaciones de dos saltos.'
  }, {
    title: 'TOMO 5 — Avanzado Niños (Parte 1)',
    desc: 'Axel, Rittberger, trompo camel y combinaciones de tres saltos.'
  }, {
    title: 'TOMO 6 — Avanzado Niños (Parte 2)',
    desc: 'Doble Salchow, doble Mapes, trompo completo y programa de competencia.'
  }];
  const adultos = [{
    title: 'TOMO 7 — Inicial Adultos (Parte 1)',
    desc: 'Seguridad, confianza, caída controlada y primeros deslices sin miedo.'
  }, {
    title: 'TOMO 8 — Inicial Adultos (Parte 2)',
    desc: 'Cruces adelante, Mohawk, trompo en dos pies y secuencia final de nivel inicial.'
  }, {
    title: 'TOMO 9 — Intermedio Adultos (Parte 1)',
    desc: 'Three Turn adulto, Vals completo, Salchow y trompo interior atrás.'
  }, {
    title: 'TOMO 10 — Intermedio Adultos (Parte 2)',
    desc: 'Mapes, Flip, trompo bajo inicial y programa personal de exhibición.'
  }, {
    title: 'TOMO 11 — Avanzado Adultos (Parte 1)',
    desc: 'Lutz, Rittberger, Axel adulto y trompo camel completo.'
  }, {
    title: 'TOMO 12 — Avanzado Adultos (Parte 2)',
    desc: 'Combinaciones avanzadas, trompo completo y coreografía final personal.'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-287">
      <div className="max-w-6xl mx-auto px-4" data-id="element-288">
        <div className="text-center mb-16" data-id="element-289">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-290">
            Los 12 Tomos Completos
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-291">
            Ejercicios graficados · Por nivel y objetivo · Listo para usar
            mañana
          </p>
          <div className="w-24 h-1 bg-brand-500 mx-auto mt-8 rounded-full" data-id="element-292"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16" data-id="element-293">
          {/* MÓDULO NIÑOS */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100" data-id="element-294">
            <h3 className="text-2xl font-bold text-brand-700 mb-8 flex items-center gap-3" data-id="element-295">
              <span className="text-3xl" data-id="element-296">🛼</span> MÓDULO NIÑOS
            </h3>
            <div className="space-y-6" data-id="element-297">
              {ninos.map((tomo, i) => <div key={i} className="border-b border-gray-100 pb-6 last:border-0 last:pb-0" data-id="element-298">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-299">{tomo.title}</h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-300">
                    {tomo.desc}
                  </p>
                </div>)}
            </div>
          </div>

          {/* MÓDULO ADULTOS */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100" data-id="element-301">
            <h3 className="text-2xl font-bold text-brand-700 mb-8 flex items-center gap-3" data-id="element-302">
              <span className="text-3xl" data-id="element-303">🛼</span> MÓDULO ADOLESCENTES & ADULTOS
            </h3>
            <div className="space-y-6" data-id="element-304">
              {adultos.map((tomo, i) => <div key={i} className="border-b border-gray-100 pb-6 last:border-0 last:pb-0" data-id="element-305">
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-306">{tomo.title}</h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-307">
                    {tomo.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-308">
          <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 font-medium text-gray-800" data-id="element-309">
            ✏️ Ejercicios graficados en cada tomo
          </div>
          <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 font-medium text-gray-800" data-id="element-310">
            ⚡ Sistema "Abrí y Enseñás"
          </div>
          <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 font-medium text-gray-800" data-id="element-311">
            📋 Planillas listas para imprimir
          </div>
          <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 font-medium text-gray-800" data-id="element-312">
            🇦🇷 Contenido 100% adaptado a Argentina
          </div>
        </div>
      </div>
    </section>;
};